import { render } from "./Upload.vue?vue&type=template&id=0f27d316"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f27d316"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f27d316', __exports__)) {
    api.reload('0f27d316', __exports__)
  }
  
  module.hot.accept("./Upload.vue?vue&type=template&id=0f27d316", () => {
    api.rerender('0f27d316', render)
  })

}


export default __exports__